import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'core/core.module';
import { CoursesModule } from '../courses/courses.module';
import { SendDiplomaComponent, ChangesAccessComponent } from './itineraries/bulk-actions-itineraries';
import { ItinerariesRoutingModule } from './itineraries-routing.module';
import { ItinerariesService } from 'core/services/itineraries.service';
import { ItinerariesComponent } from './itineraries/itineraries.component';
import { ItineraryCreateComponent } from './itinerary-create/itinerary-create.component';
import { ItineraryDetailComponent } from './itinerary-detail/itinerary-detail.component';
import { ItineraryEditorComponent } from './itinerary-editor/itinerary-editor.component';
import { ItineraryTranslationsComponent } from './itinerary-translations/itinerary-translations.component';
import { ItineraryTranslationsEditorComponent } from './itinerary-translations/itinerary-translations-editor/itinerary-translations-editor.component';
import { ItineraryTranslationsListComponent } from './itinerary-translations/itinerary-translations-list/itinerary-translations-list.component';
import { NoItinerariesComponent } from './no-itineraries/no-itineraries.component'; // TODO itinerary move to no courses
import { NoItineraryTranslationsComponent } from './itinerary-translations/no-itinerary-translations/no-itinerary-translations.component';
import { ItinerariesQuestionsService } from './services/itineraries-questions.service';

@NgModule({
  declarations: [
    ItinerariesComponent,
    ItineraryCreateComponent,
    ItineraryDetailComponent,
    ItineraryEditorComponent,
    ItineraryTranslationsComponent,
    ItineraryTranslationsEditorComponent,
    ItineraryTranslationsListComponent,
    NoItinerariesComponent,
    NoItineraryTranslationsComponent,
    SendDiplomaComponent,
    ChangesAccessComponent
  ],
  imports: [CommonModule, CoreModule, CoursesModule, ItinerariesRoutingModule],
  exports: [ItinerariesComponent],
  providers: [ItinerariesService, ItinerariesQuestionsService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ItinerariesModule {}
